import React from 'react';
import { Link } from 'react-router-dom';
import './CategoryGrid.css';

export default function CategoryGrid({ categories, cityName, stateSlug, citySlug }) {
    return (
        <section className="category-section">
            <div className="category-container">
                <div className="category-header">
                    <h2 className="category-title">Categories in {cityName}</h2>
                    <p className="category-subtitle">Find exactly what you're looking for</p>
                </div>

                <div className="category-grid">
                    {categories?.map((cat) => (
                        <Link key={cat.slug} to={`/in/${stateSlug}/${citySlug}/${cat.slug}`} className="category-card">
                            <div className="category-icon-wrapper">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="3" width="7" height="7" />
                                    <rect x="14" y="3" width="7" height="7" />
                                    <rect x="14" y="14" width="7" height="7" />
                                    <rect x="3" y="14" width="7" height="7" />
                                </svg>
                            </div>
                            <h3 className="category-name">{cat.name}</h3>
                            <div className="category-count">
                                <span className="count-badge">{cat.count || 0} Listings</span>
                            </div>
                            <svg
                                className="category-arrow"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
